import ColorKeyBar from './ColorKeyBar'

export default ColorKeyBar
